// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components----Products-module---wrapper---2a9Ak","header":"src-components----Products-module---header---Fw1Qq","container":"src-components----Products-module---container---3v2AM","section":"src-components----Products-module---section---3Ijj1","sections":"src-components----Products-module---sections---28wbd","product":"src-components----Products-module---product---2rjfx","barbro":"src-components----Products-module---barbro---1jUdO","podspace":"src-components----Products-module---podspace---3iYtE","content":"src-components----Products-module---content---3fJpD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Products.module.css
// module id = 130
// module chunks = 35783957827783 43201937662106